import Vue from "vue";

Vue.filter("formatNumber", (value) => {
  try {
    value = value.toFixed(2);
    return new Intl.NumberFormat("es-CL").format(value);
  } catch (e) {
    return value;
  }
});
